/**
 * Direct GraphQL Client for CDK AppSync API
 * Replaces Amplify GraphQL client with pure AWS SDK approach
 */
import { cdkConfig } from '../utils/cdkConfig';

export class GraphQLClient {
  private endpoint: string;
  
  constructor() {
    this.endpoint = cdkConfig.graphql.endpoint;
  }

  /**
   * Execute GraphQL query/mutation with JWT authentication
   */
  async request<T = any>(
    query: string,
    variables?: Record<string, any>
  ): Promise<{ data: T; errors?: any[] }> {
    try {
      // Get JWT token from localStorage
      const token = localStorage.getItem('accessToken');
      
      if (!token) {
        throw new Error('No authentication token found');
      }

      console.log('GraphQL Request:', {
        endpoint: this.endpoint,
        query: query.substring(0, 100) + '...',
        variables,
        hasToken: !!token
      });

      const response = await fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          query,
          variables: variables || {},
        }),
      });

      console.log('GraphQL Response Status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('GraphQL HTTP Error:', response.status, errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }

      const result = await response.json();
      console.log('GraphQL Result:', result);
      
      if (result.errors) {
        console.error('GraphQL errors (detailed):', JSON.stringify(result.errors, null, 2));
      }

      return result;
    } catch (error) {
      console.error('GraphQL request failed:', error);
      throw error;
    }
  }

  /**
   * Execute GraphQL query
   */
  async query<T = any>(
    query: string,
    variables?: Record<string, any>
  ): Promise<T> {
    const result = await this.request<T>(query, variables);
    return result.data;
  }

  /**
   * Execute GraphQL mutation
   */
  async mutate<T = any>(
    mutation: string,
    variables?: Record<string, any>
  ): Promise<T> {
    const result = await this.request<T>(mutation, variables);
    return result.data;
  }
}

// Export singleton instance
export const graphqlClient = new GraphQLClient();